import { render, staticRenderFns } from "./ContestCategoryListComponent.vue?vue&type=template&id=18cf1c1d"
import script from "./ContestCategoryListComponent.vue?vue&type=script&lang=js"
export * from "./ContestCategoryListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports